import { PRIORITY_COUNTRY_CODES } from "@klarify/constants";
import type { CountryOption } from "@klarify/types";
import { Country } from "country-state-city";

// country-state-city is used here (rather than @klarify/constants COUNTRY_LIST) because the
// cascading country→state→city picker needs subdivision and city data that only this library
// provides, and using one dataset keeps ISO codes consistent across all three levels.
export const COUNTRY_OPTIONS: CountryOption[] = (() => {
	const all: CountryOption[] = Country.getAllCountries().map((c) => ({
		id: c.isoCode,
		label: c.name,
	}));
	const pinned = PRIORITY_COUNTRY_CODES.map((code) =>
		all.find((c) => c.id === code),
	).filter((c): c is CountryOption => Boolean(c));
	const rest = all
		.filter(
			(c) =>
				!PRIORITY_COUNTRY_CODES.includes(
					c.id as (typeof PRIORITY_COUNTRY_CODES)[number],
				),
		)
		.sort((a, b) => a.label.localeCompare(b.label));
	return [...pinned, ...rest];
})();
